
import { computed, defineComponent, Ref } from 'vue';
import offersStore from '../offers.store';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import OffersThumbView from '@/b2c/offers/ui/OffersThumbView.vue';
import FindPersonalOffer from '@/b2c/offers/ui/FindPersonalOffer.vue';
import { PersonalOfferOverviewModel } from '@/b2c/shared/api/server-apis';

export default defineComponent({
    name: 'Offers',
    components: { FindPersonalOffer, OffersThumbView },
    props: {
        detailsUrl: {
            type: String,
            required: true,
        },
    },
    setup() {
        const labels = useBlockLabels();

        const offers: Ref<PersonalOfferOverviewModel[]> = computed(() => {
            return offersStore.offers;
        });

        const maybePendingText: Ref<string> = computed(() => {
            return offersStore.pending ? labels.loadingOffersText : labels.noOffersFoundText;
        });

        offersStore.updateOffers();

        return {
            offers,
            labels,
            maybePendingText,
        };
    },
});
